<template>
  <div class="layout" id="firstPage">
    <Layout>
      <Sider ref="side1" hide-trigger collapsible :collapsed-width="78" width="220">
        <div class="my-icon" key="orgIco">
          <img :src="orgIco" alt v-if="orgIco" />
          <span class="org-name">{{ organizationName }}</span>
        </div>
        <Menu :active-name="activeMenu" :open-names="openNames" theme="dark" width="220" @on-select="menuSelect"
          ref="leftMenu" class="menuBox">
          <template v-for="(menu, i) in menus">
            <MenuItem :name="menu.code" :key="menu.code" v-if="menu.url != '#'">
            <span style="margin-left: -27px" class="iconfont" :class="menu.ico" v-if="menu.ico"></span>
            {{ menu.name }}
            </MenuItem>
            <Submenu :name="menu.code" :key="menu.code" v-else>
              <template slot="title">
                <span class="iconfont" :class="menu.ico" v-if="menu.ico"></span>
                {{ menu.name }}
              </template>
              <template v-if="menu.children">
                <div v-for="child in menu.children" :key="child.code">
                  <MenuItem v-if="child.url != '#'" :name="child.code" class="item-level2">
                  {{ child.name }}
                  </MenuItem>
                  <Submenu :name="child.code" v-else class="title-level2">
                    <div slot="title">
                      <span class="iconfont" :class="child.ico" v-if="child.ico"></span>
                      {{ child.name }}
                    </div>
                    <template v-if="child.children">
                      <MenuItem :name="child2.code" v-for="child2 in child.children" :key="child2.code" class="level3">
                      {{ child2.name }}
                      </MenuItem>
                    </template>
                  </Submenu>
                </div>
              </template>

            </Submenu>
          </template>
        </Menu>
      </Sider>
      <Layout>
        <Content>
          <div class="picTaps">
            <!-- 顶部 -->
            <div class="nav clearfix">
              <div class="left" style="float: left">
                <Breadcrumb separator="<i class='ivu-icon ivu-icon-ios-arrow-forward'></i>">
                  <BreadcrumbItem @click.native="toggNav(item, index, navList)" v-for="(item, index) in navList"
                    :key="index">{{ item && item.name }}</BreadcrumbItem>
                </Breadcrumb>
              </div>
              <div class="right clearfix" style="position: relative">
                <div class="userBox clearfix" style="float: right">
                  <div @click="goSearchTool" class="bg-btn">
                    <div class="iconfont iconzizhuchaxungongju"></div>
                    <div style="margin-top: 0;cursor: pointer;">自主查询工具
                    </div>
                  </div>
                  <div @click="toggleNews" class="bg-btn">
                    <div class="iconfont iconxiaoxigonggao">
                      <div class="_dot" v-if="numTotal > 0"></div>
                    </div>
                    <div style="margin-top: 0;cursor:pointer">消息公告<span v-if="numTotal>0">（{{numTotal}}）</span></div>
                  </div>
                  <a class="bg-btn" :href="userType == 4
                      ? 'https://www.yuque.com/books/share/bba210ea-e611-4701-875e-8b785441a211'
                      : 'https://www.yuque.com/books/share/838f62d0-50bf-4b39-98b5-c512327862c8'
                    " target="_blank">
                    <div class="iconfont iconshiyongxiangdao"></div>
                    <div style="margin-top: 0">使用向导</div>
                  </a>
                  <div class="dropdown-menu">
                    <Dropdown transfer-class-name="slider-top-drop" trigger="hover" placement="bottom-end">
                      <div class="dropdown-menu-btn">
                        <div class="user-name-box">
                          <span>{{ userName }}</span>
                          <Icon type="ios-arrow-down" />
                        </div>
                        <span class="company">{{ organizationName }}</span>
                      </div>

                      <DropdownMenu slot="list">
                        <DropdownItem @click.native="cPassword">账户设置</DropdownItem>
                        <DropdownItem @click.native="outLogin">退出登录</DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </div>
            <tag-list @openPage="openPage"></tag-list>
          </div>
          <!--          <router-view></router-view>-->
          <iframe class="iframeDom" frameborder="0" :src="iframeUrl" ref="iframe" id="iframe" name="myIframe"
            v-show="!currentUrl2"></iframe>
          <iframe class="iframeDom" :src="currentUrl2" frameborder="0" ref="iframe" id="iframe2"
            v-if="currentUrl2"></iframe>
          <!-- <div
            class="slideBox"
            v-if="(isShowBar && userType != 1) || activeMenu == 'index'"
          >
            <div class="inner">
              <div class="item">
                <Poptip trigger="hover" placement="left">
                  <div
                    class="iconfont iconweixin1"
                    style="font-size: 28px; color: #a8adb7; cursor: pointer"
                  ></div>
                  <div style="cursor: pointer">公众号</div>
                  <div slot="content">
                    <div style="margin-top: 10px">
                      <div>微信扫码关注</div>
                      <div>“蜡烛云”公众号</div>
                      <div>随时随地管理业务</div>
                      <img
                        src="@/static/images/yf2.png"
                        alt
                        style="width: 160px"
                      />
                    </div>
                  </div>
                </Poptip>
              </div>
            </div>
          </div> -->
        </Content>
      </Layout>
    </Layout>
    <Modal v-model="isShowChangePassword" width="780" title="修改密码" @on-ok="confirmChangePassWord"
      :loading="$root.$children[0].modalLoading">
      <Form :model="changePassword" class="changeChild" ref="changePasword" :rules="changePasswordRule" :label-width="80">
        <Row :gutter="10">
          <Col span="24">
          <FormItem label="原密码" prop="oldPassword">
            <input v-model="changePassword.oldPassword" placeholder="请输入原密码" class="ivu-input"
              :type="isSee ? 'text' : 'password'" />
            <img src="@static/images/login/eye.png" class="password-eye" v-if="!isSee" @click="isSee = true" alt />
            <Icon type="ios-eye" v-else @click="isSee = false" class="password-eye" />
          </FormItem>
          </Col>
          <Col span="24">
          <FormItem label="新密码" prop="newPassword">
            <input v-model="changePassword.newPassword" placeholder="请输入新密码，密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种"
              class="ivu-input" :type="isSee1 ? 'text' : 'password'" />
            <img src="@static/images/login/eye.png" class="password-eye" v-if="!isSee1" @click="isSee1 = true" alt />
            <Icon type="ios-eye" v-else @click="isSee1 = false" class="password-eye" />
          </FormItem>
          </Col>
          <Col span="24">
          <FormItem label="确认密码" prop="password">
            <input v-model="changePassword.password" placeholder="请确认新密码，密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种"
              class="ivu-input" :type="isSee2 ? 'text' : 'password'" />
            <img src="@static/images/login/eye.png" class="password-eye" v-if="!isSee2" @click="isSee2 = true" alt />
            <Icon type="ios-eye" v-else @click="isSee2 = false" class="password-eye" />
          </FormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
    <accountSettingModal
      ref="accountSettingModal"
      :is-operation-account="userType === '1'"
      @changePassword="togglePassword"
    ></accountSettingModal>
    <!-- 操作指引 -->
    <dirction v-if="isUseDir" :step="step" @next="nextStep" :curTop="curTop" />
    <!-- 首次登录强制修改密码 暂时不要了 -->
    <!-- <Modal
      v-model="showEditPwd"
      class-name="vertical-center-modal phone-valid-box"
      width="500"
      :closable="false"
      :mask-closable="false"
    >
      <div slot="header" style="text-align: center">
        <h1 class="phone-valid-title">修改密码</h1>
        <p class="phone-valid-tip">您的密码安全性较弱，请重新设置</p>
      </div>
      <div class="phone-code-container">
        <div class="phone-code-box phone-input">
          <Icon class="icon-phone" type="ios-lock-outline" />
          <input
            type="password"
            v-model="oldPwd"
            placeholder="请输入您的旧密码"
          />
        </div>
        <div class="phone-code-box phone-input">
          <Icon class="icon-phone" type="ios-lock-outline" />
          <Input
            v-model="newPwd"
            placeholder="请输入新密码"
            type="password"
            :password="true"
            :border="false"
          ></Input>
        </div>
        <div class="phone-code-box phone-input">
          <Icon class="icon-phone" type="ios-lock-outline" />
          <Input
            v-model="newPwdAgain"
            placeholder="请再次输入新密码"
            type="password"
            :password="true"
            :border="false"
          ></Input>
        </div>
        <div class="tip">
          注：新密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种
        </div>
      </div>
      <div slot="footer">
        <Button
          type="primary"
          size="large"
          @click="editUserInfo"
          :disabled="newPwdAgain.length == 0"
          >保存</Button
        >
      </div>
    </Modal>-->
    <!-- 隐私协议 -->
    <Modal v-model="protocolShow" title="保险中介云隐私政策概要" class-name="vertical-center-modal protocol-box" ok-text="我同意"
      cancel-text="不同意并退出" :closable="false" :mask-closable="false" @on-ok="confirmProtocol" @on-cancel="outLogin"
      width="650px">
      <div class="protocol-content">
        <p>
          欢迎您使用我们的产品和服务！我们深知个人信息对您的重要性，您的信任对我们非常重要，我们将根据法律法规要求并参照行业最佳实践为您的个人信息安全提供充分保障。鉴于此，保险中介云制定本《隐私政策》（下称“本政策
          /本隐私权政策”）以帮助您充分了解在您使用我们的产品与/或服务时，我们如何收集、使用、保存、共享和转让这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。您在使用我们的产品或服务前请仔细阅读并确认您已经充分理解本隐私政策所写明的内容并接受所有的服务条款。
        </p>
        <p style="margin-top: 20px">本政策将帮助到您了解以下内容：</p>
        <p>一、我们如何收集和使用您的个人信息。</p>
        <p>二、我们如何使用Cookies和同类技术。</p>
        <p>三、我们如何“共享”“转让”“公开披露”您的个人信息。</p>
        <p>四、我们如何保护和保存您的个人信息。</p>
        <p>五、您如何管理个人信息。</p>
        <p>六、未成年人的个人信息保护。</p>
        <p>七、通知和修订。</p>
        <p>八、如何联系我们。</p>
        <p style="margin-top: 20px">
          您可以查看完整版
          <span @click="openProtocol" class="protocol-link">《保险中介云隐私政策》</span>
        </p>
      </div>
    </Modal>
    <!-- 完整协议 -->
    <Modal v-model="completeProtocolShow" title="保险中介云隐私政策" class-name="vertical-center-modal" :footer-hide="true"
      width="1200px">
      <div>
        <iframe src="/public/privacy.html" width="1180px" height="700px" frameborder="0"></iframe>
      </div>
    </Modal>
    <!-- 人员晋升提醒 -->
    <Modal v-model="promotionShow" class-name="vertical-center-modal promotion-box" ok-text="立即查看" cancel-text="我已知晓"
      :closable="false" :mask-closable="false" @on-ok="toSee" @on-cancel="read" width="1000px">
      <div class="promotion-content">
        <div class="promotion-title">您有新的人员已达到晋升要求，请查看</div>
        <div style="
            margin-bottom: 20px;
            overflow-y: auto;
            max-height: calc(100vh - 300px);
          ">
          <Table :columns="promotionColumns" :data="promotionList"></Table>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
//当前实例组件
import _ from "lodash";
import dirction from "@/components/commons/dirction";
let vm = "";
import myForm from "@/components/commons/form";
import tagList from "@/components/system/tagList";
import accountSettingModal from "./form/accountSettingModal";

import {
  getAcconutInfo,
  changeAcconutInfo,
  getRolesType,
  lookChatReadNum,
} from "@/api/httpList";
export default {
  data() {
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value !== this.changePassword.newPassword) {
        callback(new Error("两次密码输入不一致"));
      } else {
        callback();
      }
    };
    return {
      // showEditPwd: false, //强制修改密码弹窗
      // oldPwd: "", //旧密码

      newPwd: "", //新密码
      newPwdAgain: "", //再次输入新密码
      currentUrl2: "", //2级页面
      iframeUrl: "",
      numTotal: 0,
      navIcon: [
        {
          code: "index",
          name: "nav_home",
        },
        {
          code: "financial",
          name: "nav_cw",
        },
        {
          code: "org",
          name: "nav_org",
        },
        {
          code: "order",
          name: "nav_order",
        },
        {
          code: "customer",
          name: "nav_per",
        },
        {
          code: "shop",
          name: "nav_sw",
        },
        {
          code: "systemSet",
          name: "nav_set",
        },
      ],
      userType: "",
      orgIco: "",
      curTop: 0,
      step: 0,
      isUseDir: false,
      organizationName: "",
      isShowChangePassword: false,
      isShowBar: true,
      navList: [],
      curUrl: "",
      delayerMenu: [],
      openNames: [],
      isCollapsed: false,
      userName: "",
      changePassword: {
        isShow: false,
        password: "",
        newPassword: "",
        oldPassword: "",
      },

      changePasswordRule: {
        password: [
          { validator: validatePassCheck, trigger: "blur", required: true },
          {
            pattern:
              /((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,16}$))/,
            message:
              "密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种",
          },
        ],
        newPassword: [
          { required: true, message: "值不能为空！", trigger: "blur" },
          {
            pattern:
              /((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,16}$))/,
            message:
              "密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种",
          },
        ],
        // oldPassword: [
        //   { required: true, message: "值不能为空！", trigger: "blur" },
        //   {
        //     pattern: /((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,16}$))/,
        //     message: "密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种"
        //   }
        // ],
      },
      menus: [],
      right_taps: [],
      tap_more: ["关闭当前右侧标签", "关闭当前以外全部标签", "关闭全部标签"],
      activeMenu: "",
      protocolShow: false,
      completeProtocolShow: false,
      isSee: false,
      isSee1: false,
      isSee2: false,
      promotionShow: false,
      isGroupLeader:false,//是否为团队长，团队长显示团队继续率统计
      promotionList: [],
      promotionColumns: [
        {
          title: "序号",
          align: "center",
          width: 80,
          type: "index",
        },
        {
          title: "姓名",
          key: "userName",
          align: "center",
        },
        {
          title: "工号",
          key: "code",
          align: "center",
        },
        {
          title: "机构",
          key: "organName",
          align: "center",
          minWidth: 200,
        },
        {
          title: "团队",
          key: "groupName",
          align: "center",
          minWidth: 200,
        },
        {
          title: "现职级",
          key: "oldRankName",
          align: "center",
        },
        {
          title: "晋升职级",
          key: "newRankName",
          align: "center",
        },
      ],
    };
  },
  computed: {
    navArr() {
      if (this.curUrl) {
        const arr = this.curUrl;
        return [{ name: "首页", path: "/" }].concat({
          name: arr.name,
          path: arr.url,
        });
      }
    },

    currentUrl() {
      const res = this.delayerMenu.find(
        (item) => item.code === this.activeMenu
      );
      let url = "";
      if (res) {
        this.curUrl = res;
        url = res.url;
      } else {
        if (this.delayerMenu.find((item) => item.url == "/home")) {
          url = "/home";
        } else {
          if (this.delayerMenu[1]) {
            url = this.delayerMenu[1].url;
          }
        }
      }
      if (url) {
        if (!this.iframeUrl) {
          this.iframeUrl = url;
        } else {
          // this.openPage(url);
        }
      }
      return url;

      // if (res) {
      //   this.curUrl = res;
      //   return this.$config.htmlUrl + res.url;
      // } else {
      //   if (this.delayerMenu.find((item) => item.url == "/home")) {
      //     return this.$config.htmlUrl + "/home";
      //   } else {
      //     if (this.delayerMenu[1]) {
      //       return this.$config.htmlUrl + this.delayerMenu[1].url;
      //     }
      //   }
      // }
    },
  },
  components: {
    myForm,
    dirction,
    tagList,
    accountSettingModal
  },
  async created() {
    let basePass = localStorage.basePass;
    if (basePass) {
      basePass = JSON.parse(basePass);
      this.formInline = basePass;
    }
    await this.getDicAll();
    await this.getUserInfo();
    this.getList();
    this.getPromotionList();
  },
  mounted() {
    vm = this;
    this.getReadNum();
    // // //监听iframe传过来的信息
    window.addEventListener("message", (e) => {
      if (!e.data.appMessage) {
        return;
      }
      if (e.data.openPage) {//新开二级页面
        this.currentUrl2 = e.data.page;
        return;
      }
      if (e.data.reloadReadNum) {//阅读数
        this.getReadNum()
        return;
      }
      if (e.data.updateUserinfo) {//更新用户信息
        this.getUserInfo()
        return;
      }
      // console.log("iframe.message",e.data)
      //取iframe内部数据
      // if (this.activeMenu == "index") {
      //   this.navList = [
      //     {
      //       name: "首页",
      //       path: "/",
      //     },
      //   ];
      //   return;
      // }
      if (e.data.nav) {
        if (e.data.nav.length > 0 && this.delayerMenu.length > 0) {
          this.navList = e.data.nav;
        } else {
          this.navList = [
            {
              name: "首页",
              path: "/",
            },
          ];
        }
        const title = this.navList.slice(-1)[0].name;
        document.title = title + "-保险中介展业平台";
      }
      if (e.data.updateNav) {
        const url = e.data.updateNav;

        if (url === "/") {
          this.printLog("index");
        } else {
          const cur = this.delayerMenu.find((its) => url === its.url);
          if (cur) {
            this.printLog(cur.code);
          }
        }
      }
    });

    //
  },
  methods: {
    // 缓存字典数据
    getDicAll() {
      return this.$http({
        url: "system/dic/read/all",
        type: "GET",
        data: {}
      }).then((res) => {
        localStorage.dic = JSON.stringify(res.data);
      })
    },
    getReadNum() {
      lookChatReadNum().then((res) => {
        if (res.data[0]) {
          this.numTotal = +res.data[0].count;
        }
      });
    },
    // 移除当前顶部导航
    removeTaps(i) {
      this.right_taps.splice(i, 1);
      if (i > 0) {
        this.activeMenu = this.right_taps[i - 1].code;
      } else {
        this.activeMenu = this.right_taps[0].code;
      }
    },
    //修改密码暂时不要了
    // editUserInfo() {
    //   if (!this.oldPwd) {
    //     this.$notice.error("请输入旧密码");
    //     return;
    //   }
    //   if (!this.newPwd) {
    //     this.$notice.error("请输入新密码");
    //     return;
    //   }
    //   if (!this.newPwdAgain) {
    //     this.$notice.error("请再次输入新密码");
    //     return;
    //   }
    //   if (this.newPwd != this.newPwdAgain) {
    //     this.$notice.error("两次输入的新密码不一致");
    //     return;
    //   }
    //   if (!this.verification(this.newPwd)) {
    //     return;
    //   }
    //   this.loading = true;
    //   this.$http({
    //     type: "POST",
    //     url: "/system/users/modifyAccount",
    //     data: {
    //       // oldPassword: this.oldPwd,
    //       newPassword: this.newPwd,
    //       confirmPassword: this.newPwdAgain,
    //     },
    //   })
    //     .then((res) => {
    //       this.loading = false;
    //       //修改完密码关闭弹窗
    //       if (res.httpCode == 1) {
    //         this.showEditPwd = false;
    //         this.$notice.success("密码重置成功");
    //       }
    //     })
    //     .catch((e) => {
    //       this.loading = false;
    //     });
    // },
    //校验密码
    verification(password) {
      const capital = /[A-Z]/;
      const regLetter = /[a-z]/;
      const regNum = /[0-9]/;
      const regTeShu = new RegExp(
        "[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？+-]"
      );

      let complex = 0;
      if (capital.test(password)) {
        ++complex;
      }
      if (regLetter.test(password)) {
        ++complex;
      }
      if (regNum.test(password)) {
        ++complex;
      }
      if (regTeShu.test(password)) {
        ++complex;
      }
      if (complex < 3 || password.length < 8 || password.length > 16) {
        this.$notice.error(
          "密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种"
        ); //iview中的一个提示框
        return false;
      } else {
        return true;
      }
    },
    // 跳转查询工具
    goSearchTool() {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.$http({
        type: "get",
        url: "/buz/productBase/getSign",
        data: {
          type: 2,// 1-商户后台  2-业务员后台
          userId: userInfo.userid
        }
      }).then((res) => {
        window.open(res.data);
      })
    },
    toggleNews() {
      this.$refs.iframe.contentWindow.postMessage({ toggleNews: 1 }, "*");
    },
    openPage(url) {
      this.$refs.iframe.contentWindow.postMessage({ refreshPageUrl: url }, "*");
    },
    //下一步
    nextStep(over) {
      if (over) {
        this.isUseDir = false;
        return;
      }
      this.step++;
      if (this.step == 5) {
        //切换服务费模板
        this.menuSelect("pro_3");
      } else if (this.step == 6) {
        //商城装修
        this.menuSelect("shop_1");
      } else if (this.step == 7) {
        //财务管理
        this.menuSelect("financialSh_1");
      }
    },
    //新手指引
    useDirction() {
      this.isUseDir = true;
      this.step = 1;
      this.toggleDirction();
    },
    toggleDirction() {
      this.menuSelect("org_1");
      // this.$router.push({ name: "/systems/organization" });
    },
    confirmChangePassWord() {
      this.$units.notCloseModal(this);
      this.$refs["changePasword"].validate(async (valid) => {
        if (valid) {
          const { password, newPassword, oldPassword } = this.changePassword;
          const obj = {
            newPassword: newPassword,
            oldPassword: oldPassword,
            confirmPassword: password,
          };
          if (!this.verification(obj.newPassword)) {
            return;
          }
          // console.log(obj);
          // console.log(obj);
          await changeAcconutInfo(obj);
          this.$Message.success("修改成功");
          localStorage.removeItem("hasLogin");
          this.$units.goLogin();
        }
      });
    },
    //切换面包屑
    toggNav(item, index, arr) {
      if (item.noclick) {
        return;
      }
      if (arr.length === index + 1) return;
      if (index != 0) {
        const url = item.path;
        const cur = this.delayerMenu.find((its) => its.url == item.path);
        if (cur) {
          window.iframe.contentWindow.postMessage({ refreshPageUrl: url }, "*");
          sessionStorage.setItem("currentActiveMenu", cur.code);
        } else {
          history.go(-1);
        }
      } else {
        //首页
        sessionStorage.setItem("currentActiveMenu", "index");
      }
    },
    testVuex() {
      this.printLog("index");
      sessionStorage.setItem("currentActiveMenu", "index");
      // console.log(this.$store.state);
    },
    //扁平化数据
    arrDelayering(arr) {
      // 树形 => 扁平化
      let result = [];
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i];
        var res = JSON.parse(JSON.stringify(item)); // 先克隆一份数据作为第一层级的填充  
        delete res["children"];   
        result.push(res);
        if (item.children instanceof Array && item.children.length > 0) {
          // 如果当前child为数组并且长度大于0，才可进入flag()方法
          result = result.concat(this.arrDelayering(item.children));
        }
      }
      return result;
    },
    async getRolesStatus() {
      const { data } = await getRolesType();
      return data;
    },
    togglePassword() {
      this.isShowChangePassword = true;
      this.isSee = false;
      this.isSee1 = false;
      this.isSee2 = false;
      this.$refs["changePasword"].resetFields();
    },

    async cPassword() {
      // 回填账号信息
      const { data } = await getAcconutInfo();
      // 使用组件内部的open方法显示弹窗
      this.$refs.accountSettingModal.open(data);
    },
    getUserInfo() {
      return new Promise(resolve => {
        this.$http({
          type: "get",
          url: "/system/info/userinfo",
        }).then((res) => {
          if (!res.data.mobile) {
            //强制退出登录
            this.outLogin();
          }
          this.userType = res.data.userType;
          localStorage.organizationName = res.data.organizationName;
          // if(res.data.orgIco){
          //   this.orgIco = res.data.orgIco;
          //   localStorage.orgIco = res.data.orgIco;
          //   localStorage.organizationName = res.data.organizationName;
          //   document.getElementById("webIcon").href = res.data.orgIco;
          // }else{
          //   this.orgIco = "";
          //   localStorage.orgIco = "";
          //   document.getElementById("webIcon").href = "/favicon.png";
          // }
          //是否首次登录
          // if (res.data.firstLogin == "1") {
          //   this.showEditPwd = true;
          // }

          if (res.data.privacyConfirm == "0" && this.userType != 1) {
            this.protocolShow = true;
          }
          const hasUsed = localStorage.getItem("hasUsed");
          // 用户类型 1运营 2商户 3下级机构 4业务员
          const loginType = localStorage.getItem("loginType");
          if (loginType) {
            localStorage.setItem("isFirst", 0);
          } else {
            localStorage.setItem("isFirst", 1);
          }
          const isFirst = localStorage.getItem("isFirst");
          if (isFirst == 1 && !hasUsed) {
            //首次登录，新手指引
            if (this.userType == 2 || this.userType == 3) {
              // setTimeout(() => {
              //   this.useDirction();
              //   localStorage.setItem("isFirst", 0);
              //   localStorage.setItem("hasUsed", true);
              // }, 1000);
            }
          }
          this.isGroupLeader = res.data.isGroupLeader;
          this.userName = res.data.userName;
          localStorage.setItem("userInfo", JSON.stringify(res.data));
          this.organizationName = res.data.organizationName;
          resolve(res.data)
        });
      })
    },
    refresh() {
      document.getElementById("iframe").contentWindow.location.reload(true);
    },
    getList() {
      this.$http({
        type: "get",
        url: "/system/sysMenus2/readByUser",
      })
        .then((data) => {
          if(!this.isGroupLeader){
            this.menus = this.dealData(data.data.children,'renewalManage_03_4')
          }else {
            this.menus = data.data.children;
          }
          this.delayerMenu = this.arrDelayering(this.menus);
          console.log('delayerMenu',this.delayerMenu)
          this.openNames = this.delayerMenu.map(i => i.code)
          this.activeMenu = sessionStorage.getItem("currentActiveMenu") || 'index';
          this.$nextTick(() => {
            this.$refs.leftMenu.updateActiveName();
            this.$refs.leftMenu.updateOpened();
          });
        })
        .catch((err) => { });
    },
    dealData(arr,hideCode){
      let result = [];
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i];
        if(item.code != hideCode){
          result.push(item);
        }
        if (item.children instanceof Array && item.children.length > 0) {
          // 如果当前child为数组并且长度大于0，才可进入flag()方法
          item.children = this.dealData(item.children,hideCode);
        }
      }
      return result;
    },
    // 移除当前顶部导航
    removeTaps(i) {
      this.right_taps.splice(i, 1);
      if (i > 0 && i === this.right_taps.length) {
        this.activeMenu = this.right_taps[i - 1].code;
      } else {
        if (this.right_taps.length === 0) {
          this.activeMenu = 0;
        }
      }
    },
    // 选择菜单
    menuSelect(e) {
      // if (e == "index") {
      //   sessionStorage.setItem("currentActiveMenu", "index");
      //   // window.location.reload();
      //   // this.$refs.leftMenu.updateActiveName();
      //   return;
      // }
      // this.activeMenu = "";
      this.$nextTick(() => {
        // alert(e);
        sessionStorage.setItem("currentActiveMenu", e);
        this.menuSelected = true;
        this.activeMenu = sessionStorage.getItem("currentActiveMenu");
        this.openPage(this.currentUrl);
        this.$nextTick(() => {
          this.$refs.leftMenu.updateActiveName();
          //获取激活导航定位位置
          setTimeout(() => {
            this.curTop = document
              .querySelector(".ivu-menu-item-selected")
              .getBoundingClientRect().top;
          }, 180);
        });
      });
    },
    togglePage(url) {
      this.menuSelect(url);
    },
    // 退出登录
    outLogin() {
      this.$http({
        type: "get",
        url: "/system/info/logout",
      }).then((data) => {
        localStorage.removeItem("hasLogin");
        this.$units.goLogin();
      });
    },
    openProtocol() {
      this.completeProtocolShow = true;
    },
    confirmProtocol() {
      this.$http({
        type: "get",
        url: "/system/users/confirmPrivacy",
      }).then((res) => {
        if (res.data) {
          this.protocolShow = false;
        }
      });
    },
    //节流
    printLog: _.throttle((currentActiveMenu) => {
      if (vm) {
        sessionStorage.setItem("currentActiveMenu", currentActiveMenu);
        vm.activeMenu = currentActiveMenu;
        vm.$nextTick(() => {
          vm.$refs.leftMenu && vm.$refs.leftMenu.updateActiveName();
        });
      }
    }, 1000),
    //获取可晋升列表
    getPromotionList() {
      this.$http({
        type: "get",
        url: "/buz/userPromotionRecord/getNewMsgList",
      }).then((res) => {
        if (res.data) {
          this.promotionList = res.data;
          if (res.data.length > 0) {
            this.promotionShow = true;
          }
        }
      });
    },
    //我已知晓
    read() {
      let arr = this.promotionList.map((item) => {
        return item.id;
      });
      this.$http({
        type: "post",
        url: "/buz/userPromotionRecord/readMsg",
        data: arr,
      }).then((res) => {
        if (res.data) {
          this.promotionShow = false;
        }
      });
    },
    //去查看
    toSee() {
      this.read();
      let id = this.promotionList[0].id;
      this.$store.commit("setRequestId", id);
      this.$store.commit("setMechNavList", {
        id,
      });
      sessionStorage.promotionManage_tab = "1";
      this.menuSelect("personnelMag_9");
    },
  },
  watch: {
    currentUrl() {
      this.currentUrl2 = "";
    },
    activeMenu(newVal) {
      if (!newVal) {
        return;
      }
      if (newVal && newVal != "0") {
        this.$nextTick(() => {
          // this.$refs.leftMenu.updateOpened();
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
<style lang="scss">
.slider-top-drop {
  top: 50px !important;
}
</style>
